<template>
    <div class="rule-look-container">
        <el-scrollbar  class="rule-look-scrollbar" style="height: 100%;">
            <div style="display: flex;align-items: center;justify-content: center;">
                <div :id="containerId" />
                <el-empty v-if="!nodesData.length"></el-empty>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import G6 from '@antv/g6';
import cellData from './ruleCellJson.js';
import _ from 'lodash';

export default {
    name: 'RuleLook',
    props: {
        nodesData: {
            type: Array,
            default: () => []
        },
        canEdit: {
            type: Boolean,
            default: true
        },
        containerId: {
            type: String,
            default: 'container'
        }
    },
    data() {
        return {
            nodesArray: [],
            nodesRowArray: [],
            teamBindShopDialog: null,
            hideStep: false,
            fundStep: ['', '', '一级', '二级', '三级', '四级'],
        }
    },
    watch:{
        nodesData: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    // 合并数据
                    this.dealTreeData(newVal)
                } else {
                    this.dealTreeData([])
                }
            },
            deep: true
        }
    },
    methods: {
        // step 层级 最多 4 级
        getView(data, step) {
            if (step >= 6) {
                this.hideStep = true
            }
            const container = document.getElementById(this.containerId || 'container')
            // 重置画布
            if (container) {
                container.innerHTML = ''
            }
            // const width = container.scrollWidth
            const width = step * 200;
            const height = 400
            // const height = container.scrollHeight
            const graph = new G6.Graph({
                modes: {
                    // default: ['drag-canvas', 'zoom-canvas'] // 允许拖拽画布、放缩画布、拖拽节点
                },
                container: this.containerId || 'container', // String | HTMLElement，必须，在 Step 1 中创建的容器 id 或容器本身
                fitView: true, // 是否将图适配到画布大小，可以防止超出画布或留白太多。
                minZoom: 0.5, // 最小缩放比例
                maxZoom: 1, // 最大缩放比例
                width: width, // Number，必须，图的宽度
                height: height, // Number，必须，图的高度
                // size: [100, 500],
                defaultNode: {
                    type: 'rect',
                    size: [100, 44],
                    style: {
                        fill: '#f5222d',
                        stroke: '#f5222d',
                        // lineWidth: 2,
                        radius: 3,
                        cursor: 'pointer',
                    },
                    labelCfg: {
                        style: {
                            fill: '#fff',
                            fontSize: 16,
                            fontWeight: 'bold',
                            textAlign: 'center',
                            textBaseline: 'middle',
                            cursor: 'pointer',
                        },

                    }
                },
                defaultEdge: {
                    style: {
                        stroke: '#8c8c8c'
                    },
                    labelCfg: {
                        style: {
                            fill: '#0BA557',
                            fontSize: 13,
                        },
                        refY: 10
                    }
                }
            })

            G6.registerNode('diamond', {
                options: {
                    style: {},
                    stateStyles: {
                        hover: {},
                        selected: {}
                    }
                },
                /**
                 * 绘制节点，包含文本
                 * @param  {Object} cfg 节点的配置项
                 * @param  {G.Group} group 图形分组，节点中图形对象的容器
                 * @return {G.Shape} 返回一个绘制的图形作为 keyShape，通过 node.get('keyShape') 可以获取。
                 * 关于 keyShape 可参考文档 核心概念-节点/边/Combo-图形 Shape 与 keyShape
                 */
                draw(cfg, group) { },
                /**
             * 绘制后的附加操作，默认没有任何操作
             * @param  {Object} cfg 节点的配置项
             * @param  {G.Group} group 图形分组，节点中图形对象的容器
             */
                afterDraw(cfg, group) { },
                /**
             * 更新节点，包含文本
             * @override
             * @param  {Object} cfg 节点的配置项
             * @param  {Node} node 节点
             */
                update(cfg, node) { },
                /**
             * 更新节点后的操作，一般同 afterDraw 配合使用
             * @override
             * @param  {Object} cfg 节点的配置项
             * @param  {Node} node 节点
             */
                afterUpdate(cfg, node) { },
                /**
             * 响应节点的状态变化。
             * 在需要使用动画来响应状态变化时需要被复写，其他样式的响应参见下文提及的 [配置状态样式] 文档
             * @param  {String} name 状态名称
             * @param  {Object} value 状态值
             * @param  {Node} node 节点
             */
                setState(name, value, node) { },
                /**
             * 获取锚点（相关边的连入点）
             * @param  {Object} cfg 节点的配置项
             * @return {Array|null} 锚点（相关边的连入点）的数组,如果为 null，则没有控制点
             */
                getAnchorPoints(cfg) { }
            },
                // 继承内置节点类型的名字，例如基类 'single-node'，或 'circle', 'rect' 等
                // 当不指定该参数则代表不继承任何内置节点类型
                'single-node', // 基于 single-node 为例进行扩展
            )
            // 动态设置节点样式
            // graph.node((node) => {
            //   console.log(node)
            //   return {
            //     id: node.id,
            //     type: 'rect',
            //     style: {
            //       fill: 'blue'
            //     }
            //   }
            // })
            graph.data(data) // 读取 Step 2 中的数据源到图上
            // 给节点下方展示额外的文字
            graph.on('afterrender', () => {
                graph.getNodes().forEach(node => {
                    const { textDesc1, textDesc2, textDesc3, fundStep, addText, nodeType, level } = node.getModel()
                    const bbox = node.getBBox()
                    const centerX = bbox.minX + bbox.width / 2
                    const centerY = bbox.minY + bbox.height / 2
                    const textGroup = graph.get('group').addGroup()
                    textGroup.addShape('text', {
                        attrs: {
                            text: textDesc1,
                            x: centerX,
                            y: centerY + 35,
                            textAlign: 'center',
                            textBaseline: 'middle',
                            fill: '#262626',
                            fontSize: 14
                        }
                    })
                    textGroup.addShape('text', {
                        attrs: {
                            text: textDesc2,
                            x: centerX,
                            y: centerY + 55,
                            textAlign: 'center',
                            textBaseline: 'middle',
                            type: 'rect',
                            fill: '#262626',
                            cursor: 'pointer',
                            fontSize: 14
                        }
                    })
                    textGroup.addShape('text', {
                        attrs: {
                            text: textDesc3,
                            x: centerX,
                            y: centerY + 75,
                            textAlign: 'center',
                            textBaseline: 'middle',
                            type: 'rect',
                            fill: '#262626',
                            cursor: 'pointer',
                            fontSize: 14
                        }
                    })
                    const texta = textGroup.addShape('text', {
                        attrs: {
                            text: fundStep,
                            x: bbox.x + 22,
                            y: centerY - 35,
                            textAlign: 'center',
                            textBaseline: 'left',
                            fill: '#595959',
                            fontSize: 12
                        }
                    })
                    // 添加边框
                    const bbox1 = texta.getBBox()
                    if (bbox1.height !== 0) {
                        textGroup.addShape('rect', {
                            attrs: {
                                x: bbox1.x - 8,
                                y: bbox1.y - 2,
                                width: bbox1.width + 16,
                                height: bbox1.height + 8,
                                stroke: '#8c8c8c',
                                lineWidth: 1,
                                cursor: 'pointer',
                                radius: 3
                            }
                        })
                    }


                })
            })
            graph.render() // 渲染图
        },

        dealData(dataJson) {
            // 循环数组，根据 parentId 分组，将数据添加到节点中
            // 需要两个数组，一个存储全部的节点
            // 一个存储节点指向
            let nodes = []
            let nodeToNode = []
            // 按照 parentid 分组
            const nodesByParentId = _.groupBy(dataJson, 'level')
            let nodesByParentIdArr = [];
            for (const key in nodesByParentId) {
                if (Object.hasOwnProperty.call(nodesByParentId, key)) {
                    const element = nodesByParentId[key];
                    nodesByParentIdArr.push(element)
                }
            }
            // nodesByParentIdArr数组长度为深度
            _.forEach(nodesByParentIdArr, (item, index) => {
                _.forEach(item, (i, iIndex) => {
                    const showName = i.partnerName ? i.partnerName : i.name;
                    let textWidth = 17 * showName.length
                    if (textWidth < 110) {
                        textWidth = 110
                    }
                    let obj = {
                        id: '' + i.id, // String，该节点存在则必须，节点的唯一标识
                        x: 100 * index + (index * 200), // Number，可选，节点位置的 x 值
                        y: 150 * (iIndex), // Number，可选，节点位置的 y 值
                        type: 'rect', // 矩形节点
                        size: [textWidth, 44],
                        label: showName,  // 矩形节点框内的文字
                        textDesc1: i.inFee ? `流入：${i.inFee}` : '',
                        textDesc2: i.fee ? `留存：${i.fee}` : '',
                        textDesc3: '',
                        inFee: '' + i.inFee,
                        laveFee: '' + i.laveFee,
                        fee: i.fee,
                        parentId: '' + i.parentId,
                        nodeType: '' + i.nodeType,
                        nodeName: showName,
                        level: i.level,
                    }
                    if (index == 1) {
                        obj.textDesc1 = i.ptFee ? `服务费：¥${i.ptFee}` : ''
                        obj.textDesc2 = ''
                    } else if (index == 2) {
                        const afterFee = i.inFee ? (parseFloat(i.inFee)).toFixed(2) : '0'
                        const plFee = i.ptFee ? (parseFloat(i.ptFee)).toFixed(2) : '0'
                        const beforeFee = (parseFloat(afterFee) + parseFloat(plFee)).toFixed(2)
                        const totalAfterFee = i.fee ? (parseFloat(i.fee)).toFixed(2) : '0'
                        obj.textDesc1 = `缴费前收入¥${beforeFee}`
                        obj.textDesc2 = `平台服务费¥${plFee}`
                        obj.textDesc3 = `缴费后收入¥${totalAfterFee}`
                    }
                    if (iIndex == 0) {
                        obj.fundStep = this.fundStep[index]
                        if (index > 1) {
                            obj.addText = '+ 增加'
                        }
                    }
                    nodes.push(obj)
                    if (Number(i.parentId) > 0) {
                        // iIndex > 0 弯曲线
                        //  [] = [{ x: 600, y: 500 }]
                        nodeToNode.push({
                            source: '' + i.parentId, // String，必须，起始点 id
                            target: '' + i.id, // String，必须，目标点 id
                            label: i.inFee ? '¥' + i.inFee : '', // 边的文本
                            // type: 'polyline',
                            // controlPoints: iIndex == 1 ? [{ x: 300, y: 150 }] : [],
                            style: {
                                // endArrow: true,
                                // startArrow: false,
                                endArrow: {
                                    lineDash: false,
                                    path: G6.Arrow.triangle(10, 10, 2), // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
                                    d: 2,
                                    fill: '#8c8c8c',
                                },
                            }
                        })
                    }
                })
            })
            this.nodesRowArray = nodesByParentIdArr;
            const data = {
                nodes: nodes,
                edges: nodeToNode
            }
            this.$nextTick(() => {
                this.getView(data, nodesByParentIdArr.length)
            })

        },
        dealTreeData(data) {
            let dataJson = cellData;
            // dealData(dataJson)
            // 拼接节点
            if (data.length > 0) {
                // 合并数据
                const plNode = _.find(data, (item) => {
                    return item.nodeType == 2
                })
                if (plNode) {
                    dataJson = data
                }
            }
            this.nodesArray = dataJson;
            this.dealData(dataJson)
        },
    }

}


</script>
<style lang="scss" scoped>
.rule-look-container {
    height:500px;
}
.add-step {
    width: 200px;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
}

</style>